import { useState } from 'react'
import { validateToken } from 'services/schedules'

const ERRORS_MESSAGE = {
  503: 'No momento, seu convênio encontra-se indisponível para verificação do token. Tente novamente.',
  424: 'Código inválido. Verifique novamente o token.',
  400: 'Código inválido. Verifique novamente o token.',
} as const

interface IUseValidateToken {
  isRedirecting: boolean
  isSubmitting: boolean
  errorStatusCode: keyof typeof ERRORS_MESSAGE | undefined
  onSubmit: (scheduleId: number, tokenValue: string) => Promise<{ isValid: boolean }>
}

export function useValidateToken(): IUseValidateToken {
  const [isRedirecting, setIsRedirecting] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [errorStatusCode, setErrorStatusCode] = useState<keyof typeof ERRORS_MESSAGE | undefined>(undefined)

  async function onSubmit(scheduleId: number, tokenValue: string) {
    setIsSubmitting(true)
    try {
      await validateToken(tokenValue.trim(), String(scheduleId))
      setIsRedirecting(true)

      return {
        isValid: true
      }
    } catch (err) {
      setErrorStatusCode(err)
      setIsSubmitting(false)
      return {
        isValid: false
      }
    }
  }
  return {
    isRedirecting,
    isSubmitting,
    errorStatusCode,
    onSubmit,
  }
}